import {Component, Input, OnInit} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpBundleTemplate, FeatureTogglesService, TransactionListCta, TransactionType} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {LeadUiType} from '@app/model/template-view.model';

@UntilDestroy()
@Component({
  selector: 'dcp-cta-form',
  templateUrl: './cta-form.component.html',
  styleUrls: ['./cta-form.component.scss']
})
export class CtaFormComponent implements OnInit {

  @Input() slmTransactionTypes: TransactionListCta[];
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() whitelistedTransactionTypeCodes: string[];
  @Input() buttonUiType: LeadUiType = LeadUiType.LF;
  @Input() outlineButtons = true;
  @Input() highlightFirstButton = false;
  @Input() fullWidth = false;
  @Input() disableMargin = false;
  @Input() smallButtons: boolean = false;
  @Input() isHeroSection: boolean = false;
  @Input() isPublisherSection: boolean = false;

  product$: Observable<Product>;
  transactionTypes$: Observable<TransactionType[]>;
  isPdpOpenCtaInfoPageEnabled: boolean;

  constructor(
    public transactionTypeService: TransactionTypeService,
    protected currentProductService: CurrentProductService,
    protected featureToggleService: FeatureTogglesService,
  ) {
  }

  ngOnInit() {
    this.product$ = this.currentProductService.getProduct();
    this.transactionTypes$ = this.transactionTypeService.transactionTypes$;
    this.featureToggleService.isEnabled(UNLEASH_TOGGLES.pdpOpenCtaInfoPage)
      .pipe(untilDestroyed(this)).subscribe((enabled) => this.isPdpOpenCtaInfoPageEnabled = enabled);
  }
}
